import React from 'react';
import {useIntl} from 'react-intl';

import {EditorWrapper} from './wrapper';

export const ArchivedChannel = () => {
    const {formatMessage} = useIntl();

    return (
        <EditorWrapper>
            {formatMessage({
                id: 'editor_state.archived_channel_message',
                defaultMessage: 'The archived channel is read-only',
            })}
        </EditorWrapper>
    );
};
